import { enqueueSnackbar } from "notistack";

// Call sites frequently do `.catch((error) => fireAlert(error, "error"))`,
// where `error` can be a thrown API message (string), a native Error/
// SyntaxError (e.g. res.json() failing on a non-JSON response body), or an
// arbitrary object — passing any of the non-string cases straight to the
// snackbar rendered as "[object Object]" instead of a readable message.
const toMessage = (msg: unknown): string => {
  if (typeof msg === "string") return msg;
  if (msg instanceof Error) return msg.message;
  if (msg && typeof msg === "object" && "message" in msg && typeof (msg as any).message === "string") {
    return (msg as any).message;
  }
  return "حدث خطأ غير متوقع";
};

const fireAlert = (
  msg: unknown,
  variant?: "success" | "default" | "error" | "warning" | "info" | undefined,
  vertical?: "top" | "bottom",
  horizontal?: "left" | "center" | "right"
) => {
  enqueueSnackbar(toMessage(msg), {
    variant: variant ?? "success",
    anchorOrigin: {
      vertical: vertical ?? "top",
      horizontal: horizontal ?? "center",
    },
  });
};
export default fireAlert;
